/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import useFieldApi, { UseFieldApiConfig } from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';
// eslint-disable-next-line import/no-named-default
import { default as DdfFieldArray } from '@data-driven-forms/react-form-renderer/dist/cjs/field-array';
import { flattenSchema, GridForm, GridTable } from '@td-client-frontend/common';
import _ from 'lodash';
import { useDdf } from '../../context/ddf-context';
import { trackEvent } from '../../api/piwik/piwikService';
import { PiwikCategory, PiwikAction, PiwikName } from '../../@types/common';
import GridFlex from './GridFlex';

const Grid = (props: UseFieldApiConfig, other) => {
  const { fieldKey, arrayValidator, fields, input, gridFields, searchPlaceholder, useFlex, limit } = useFieldApi(props);
  const { subForm, setSubForm } = useDdf();
  const [editField, setEditField] = useState('');
  const [editId, setEditId] = useState('');
  const { getState, change } = useFormApi();

  const setToView = () => {
    setSubForm(null);
  };

  const setToEdit = (prop: React.SetStateAction<string>) => {
    setSubForm(props.name);
    setEditField(prop);
  };

  const addNewItem = (fields: { push: () => void; name: any; length: any }) => {
    trackEvent({
      category: PiwikCategory.BUTTONS,
      action: PiwikAction.CLICKED,
      name: PiwikName.NEW_PLAN
    });
    setSubForm(props.name);
    fields.push();
    setEditField(`${fields.name}[${fields.length}]`);
  };

  const isValid = (name: any) => {
    const errors = _.get(getState(), `errors.${name}`);
    return !(errors && Object.keys(errors).length);
  };

  const cancel = (name: any, fields: void[]) => {
    setSubForm(null);
    if (subForm) {
      fields.pop();
      return;
    }
    _.set(getState(), `values.${name}`, { ..._.get(getState(), `initialValues.${name}`) });
  };

  const flattenFields = flattenSchema({ fields });
  if (editId !== _.get(getState(), ['values', '_id'])) {
    setToView();
    setEditId(_.get(getState(), ['values', '_id']));
  }
  useEffect(() => {
    change(
      '__footerOverride',
      subForm === props.name ? { name: props.name, isShown: true, fieldName: editField } : null
    );
  }, [subForm, change, editField, props.name]);

  const gridFlexModified = (fieldArray: any) => (
    <GridFlex
      fieldArrayRenderProps={fieldArray}
      gridFields={gridFields}
      flattenFields={flattenFields}
      setEdit={setToEdit}
      fieldKey={fieldKey}
      searchPlaceholder={searchPlaceholder}
      input={input}
      limit={limit}
    />
  );

  const gridTableModified = (fieldArray: any) => (
    <GridTable
      addNewItem={addNewItem}
      fieldArrayRenderProps={fieldArray}
      gridFields={gridFields}
      flattenFields={flattenFields}
      setEdit={setToEdit}
      fieldKey={fieldKey}
      searchPlaceholder={searchPlaceholder}
      input={input}
    />
  );

  return (
    <DdfFieldArray key={fieldKey} name={input.name} validate={arrayValidator}>
      {(fieldArrayRenderProps) => (
        <>
          {subForm !== props.name ? (
            !useFlex ? (
              gridTableModified(fieldArrayRenderProps)
            ) : (
              gridFlexModified(fieldArrayRenderProps)
            )
          ) : (
            <GridForm
              isValid={isValid}
              fields={fields}
              setViewMode={setToView}
              cancel={cancel}
              editField={editField}
              fieldArrayRenderProps={fieldArrayRenderProps}
            />
          )}
        </>
      )}
    </DdfFieldArray>
  );
};

export default Grid;
